export const extractInitialsFromName = (name) => {
    if (name) {
        const nameSplitted = name.toLocaleUpperCase().split(" ");

        if (nameSplitted.length >= 2) {
            //primera letra de la primera palabra + primera letra de la segunda palabra
            return nameSplitted[0][0] + nameSplitted[1][0];
        }
        //primera letra de la unica palabra + segunda letra de la unica palabra
        return nameSplitted[0][0] + nameSplitted[0][1];
    }

    return;
};

export const formattedDate = (dateISO, fullMonth = false) => {
    const months = [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
    ];

    const monthsFull = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const date = new Date(dateISO);

    const day = date.getDate();
    const month = fullMonth ? monthsFull[date.getMonth()] : months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = hours >= 12 ? "pm" : "am";

    const hourFormatted = `${hours % 12 || 12}:${minutes} ${period}`;
    return `${day} de ${month}. ${year} - ${hourFormatted}`;
}

export const formattedDeeplink = (deeplink, informationToConcat) => {
    const stringToConcat = objectToBase64(informationToConcat)

    const deeplinkFormatted = `${deeplink}/${stringToConcat}`

    return deeplinkFormatted
}

export const objectToBase64 = (obj) => {
    const jsonString = JSON.stringify(obj);
    const base64String = btoa(jsonString);
    return base64String;
}